import { render, staticRenderFns } from "./LifestyleAndOccupationInformationCN.vue?vue&type=template&id=02440400"
import script from "./LifestyleAndOccupationInformationCN.vue?vue&type=script&lang=js"
export * from "./LifestyleAndOccupationInformationCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports